module.exports = __webpack_public_path__ + "lato-regular-webfont.b2e69499cedc8fb6ed83.woff2";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/lato-regular-webfont.woff2
// module id = ../../../../../resources/layout/fonts/lato-regular-webfont.woff2
// module chunks = styles